import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/channels", label: "频道入口大全" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20 gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span
              className={`w-10 h-10 rounded-md flex items-center justify-center text-lg transition-colors ${
                solid ? "bg-primary-500 text-background-50" : "bg-background-50/15 text-background-50 backdrop-blur"
              }`}
            >
              <i className="ri-eye-2-line" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-bold text-xl tracking-wide ${
                  solid ? "text-foreground-950" : "text-background-50"
                }`}
              >
                看料社
              </span>
              <span
                className={`text-[11px] mt-0.5 ${
                  solid ? "text-foreground-500" : "text-background-50/80"
                }`}
              >
                爆料频道入口大全
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? solid
                        ? "bg-primary-100 text-primary-700"
                        : "bg-background-50/20 text-background-50"
                      : solid
                        ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                        : "text-background-50/90 hover:bg-background-50/15 hover:text-background-50"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/channels"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line" />
              进入频道
            </Link>
          </div>

          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 rounded-md flex items-center justify-center text-xl cursor-pointer transition-colors ${
              solid ? "text-foreground-900 hover:bg-background-100" : "text-background-50 hover:bg-background-50/15"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/channels"
              className="mt-1 px-4 py-3 rounded-md text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              进入频道入口大全
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}